import React, { ReactNode } from "react"

import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"

import remarkReactComponents from "../../helpers/remarkReactComponents"

import { sbAssetType } from "../../types"
import { StyledTestimonial, StyledCopy, StyledQuote, StyledSignature, StyledName } from "./partials"

export interface TestimonialsProps {
  name: string
  nationality: string
  graduation_year: string
  program: string
  quote: string
  image: sbAssetType
  font: string
}

export const TestimonialsCmp: React.FC<TestimonialsProps> = ({
  name,
  nationality,
  graduation_year,
  program,
  quote,
  image,
  font,
}) => {
  return (
    <StyledTestimonial>
      <StyledCopy>
        {quote && (
          <StyledQuote font={font}>
            {
              unified()
                .use(remarkParse)
                .use(remarkRehype)
                .use(rehypeReact as any, {
                  createElement: React.createElement,
                  components: remarkReactComponents,
                  Fragment: React.Fragment
                })
                .processSync(quote).result as ReactNode
            }
          </StyledQuote>
        )}
        <StyledSignature>
          {name && <StyledName><p>{name}</p></StyledName>}
          {nationality && <p>{nationality}</p>}
          {graduation_year && <p>{graduation_year}</p>}
          {/* {program && <p>{program}</p>} */}
        </StyledSignature>
      </StyledCopy>
      {image && <img src={image.filename} alt={image.alt} />}
    </StyledTestimonial>
  )
}
